import {
  EVENT_TOPIC_FOR_TRANSACTION_SERVER,
  EVENT_TYPE_DATAFEED_LOGOFF,
  EVENT_TYPE_TRANSACTION_LOGOFF,
  JSON_KEY_MESSAGE_TYPE,
  JSON_KEY_USER,
} from "../../common/common";
import globalsStore from "../../redux/globalsStore";
import { MSGTYPE_DF_LOGOFF, MSGTYPE_TS_LOGOFF } from "../../common/msg_types";
import { DispatchTransactionEvent } from "../events/events";

export const forceLogoffWithoutConfirm = () => {
   const state = globalsStore.getState();
   const df_user_id = state.globals.dfUserId;
   const ts_user_id = state.globals.tsUserId;
   const all_in_one_server = window.APP_CONFIG.ALL_IN_ONE_SERVER;

   if (!all_in_one_server) {
      console.log('logoff imeddiately df');
      const logoffDFProps = {
         [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_DF_LOGOFF,
         [JSON_KEY_USER]: df_user_id,
      };
      DispatchTransactionEvent(
         EVENT_TOPIC_FOR_TRANSACTION_SERVER,
         EVENT_TYPE_DATAFEED_LOGOFF,
         logoffDFProps
      );
   }

   console.log('logoff imeddiately ts: ', ts_user_id);
   const logoffTSProps = {
      [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TS_LOGOFF,
      [JSON_KEY_USER]: ts_user_id,
   };

   DispatchTransactionEvent(
      EVENT_TOPIC_FOR_TRANSACTION_SERVER,
      EVENT_TYPE_TRANSACTION_LOGOFF,
      logoffTSProps
   );
};
